
import axios from 'axios';


function deleteDuckTrigger(macAddress, trigger) {
    return axios.delete(`${process.env.VUE_APP_APIURL}/trigger/${trigger}/duck`,{
        duck: macAddress
    }).then(res => res.data);
}
function setDuckTrigger(macAddress, trigger) {
    return axios.post(`${process.env.VUE_APP_APIURL}/trigger/${trigger}/duck`,{
        duck: macAddress
    }).then(res => res.data);
}

function getDucks() {
    return axios.get(`${process.env.VUE_APP_APIURL}/ducks`)
        .then(resp => {
            return resp.data;
        });
}

function saveDuckConfig(id, duckConfig) {
    return axios.put(`${process.env.VUE_APP_APIURL}/ducks/${id}/config`, { config: duckConfig })
        .then(resp => {
            return resp.data;
        });
}

function saveDuckPeriodic(macAddress, period) {
    return axios.put(`${process.env.VUE_APP_APIURL}/ducks/${macAddress}/periodic`, { period: period })
f
}
function getDuckPeriodic(macAddress) {
    return axios.get(`${process.env.VUE_APP_APIURL}/ducks/${macAddress}/periodic`)
        .then(resp => {
            return resp.data;
        });

}
function deleteDuckPeriodic(macAddress) {
    return axios.delete(`${process.env.VUE_APP_APIURL}/ducks/${macAddress}/periodic`)
        .then(resp => {
            return resp.data;
        });


}




export default {
    getDucks,
    saveDuckConfig,
    saveDuckPeriodic,
    getDuckPeriodic,
    deleteDuckPeriodic,
    setDuckTrigger,
    deleteDuckTrigger
};